import { i18n } from '@/lib/i18n';

export function formatD9Address(address: string): string {
  if (address.length === 47 || address.length === 48) {
    return `Dn${address}`;
  }

  if (address.startsWith('Dn')) {
    return address;
  }

  throw new Error(i18n.t('errors.invalidD9Address'));
}

export function parseD9Address(address: string): string {
  if (address.length < 47) {
    throw new Error(i18n.t('errors.invalidD9Address'));
  }

  if (address.length < 51 && address.startsWith('Dn')) {
    return address.slice(2);
  }

  if (address.length < 49) return address;

  throw new Error(i18n.t('errors.invalidD9Address'));
}
